import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  root: {
    border: `1px solid ${theme.palette.grey.grey100}`,
    background: 'rgba(242, 243, 247, 0.20)',
    margin: '14px 26px',
    padding: '16px',
    maxHeight: '200px',
    overflow: 'auto',
  },
  attribute: {
    display: 'flex',
    alignItems: 'center',
    borderRadius: '24px',
    background: '#FFF',
    boxShadow: '0px 6px 16px 0px rgba(21, 12, 115, 0.06)',
    width: 'fit-content',
    margin: '8px 0px 8px 0px',
  },
  attributeName: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 'fit-content',
    borderRadius: '24px 0px 0px 24px',
    height: '40px',
    padding: '12px',
    fontSize: '14px',
    fontWeight: 'bold',
    color: theme.palette.black.dark,
  },
  indicatorBackground: {
    background: theme.palette.warning.warning200,
  },
  attributeBackground: {
    background: theme.palette.primary.primary200
  },
  nameIcon: {
    marginRight: '8px',
  },
  attributeValue: {
    width: 'fit-content',
    borderRadius: '0px 24px 24px 0px',
    fontSize: '14px',
    padding: '0 16px 0px 8px',
  },
}));

export default useStyles;
